import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import Loader from '../../components/Loader/Loader';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { postActivity, postActivityTemplate, postActivityTemplateSave, getActivityTemplateDetails, deleteActivityTemplate } from '../../apiservices/ApiServices';

const ActivityTemplate = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [data, setData] = useState([]);
    const [activitys, setActivitys] = useState([]);

    const postActivityTemplates = async (postData) => {
        setLoading(true);
        try {
            const res = await postActivityTemplate(postData);
            setData(res.data.data);
            setLoading(false);
            console.log(res.data.data)
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        try {
            const res = await postActivityTemplate(postData);
            setData(res.data.data);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };


    useEffect(() => {
        let postData = {
            search: "",
            filters: {
                document_title: ""
            },
            page: 1,
            length: 100
        }
        postActivityTemplates(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Template Name",
                accessor: "template_name",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        setIsEdit(false);
        let postData = {
            "without_sub": 1
        }
        try {
            const res = await postActivity(postData);
            setActivitys(res.data.data);
            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const initialValues = {
        id: '',
        name: '',
        description: '',
        activityIds: [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData;

            if (isEdit) {
                postData = {
                    activity_template_id: values.id,
                    template_name: values.name,
                    template_desctoption: values.description,
                    activity_ids: values.activityIds,
                }
            }
            else {
                postData = {
                    template_name: values.name,
                    template_desctoption: values.description,
                    activity_ids: values.activityIds,
                }
            }

            try {
                const res = await postActivityTemplateSave(postData);
                toast.success(res.data.message);
                postUpdates();
                setLoadings(false);
                setIsEdit(false);
                setAddModal(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        let postData = {
            without_sub: 1
        }
        try {
            const resp = await postActivity(postData);
            setActivitys(resp.data.data);

            try {
                const res = await getActivityTemplateDetails(rowData?.activity_template_id);
                setFieldValue('id', res.data?.data?.activity_template_id);
                setFieldValue('name', res.data?.data?.template_name);
                setFieldValue('description', res.data?.data?.template_description);
                setFieldValue('activityIds', res.data?.data?.activity_ids);

                setIsEdit(true);
                setLoadings(false);
                setAddModal(true);

            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.activity_template_id);
        setFieldValue('name', rowData?.template_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteActivityTemplate(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('id', '');
            setFieldValue('name', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Activity Template" active="Activity Template" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Activity Template</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit Activity Template' : 'Add New'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Template Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Template Description</label>
                                <input
                                    type='text'
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.description && touched.description && (
                                    <p className="errormsg">{errors.description}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Activity</label>
                                <SelectFild
                                    Firstop='Select Activity'
                                    selectName='activityIds'
                                    options={activitys}
                                    value={values.activityIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('activityIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('activityIds')}
                                    isMulti={true}
                                />
                                {errors.activityIds && touched.activityIds && (
                                    <p className="errormsg">{errors.activityIds}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? "Update" : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.name}</span> Activity Template ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
            {isLoadings && <Loader />}
        </>
    )
}

export default ActivityTemplate
